<template>
  <div class="page-layout">
    <navbar-top :button-text="navbarTopButtonText" :button-to="navbarTopButtonTo"></navbar-top>
    <main>
      <slot>Main content will appear here</slot>
    </main>
  </div>
</template>

<script>
import NavbarTop from '@/components/NavbarTop.vue';

export default {
  name: 'page-layout',
  components: {
    NavbarTop,
  },
  props: {
    navbarTopButtonText: {
      type: String,
      default: 'Dashboard',
    },
    navbarTopButtonTo: {
      type: String,
      default: 'dashboard',
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
.page-layout {
  padding-bottom: 70px;
}
</style>
